import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Spin } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";

const tableSubRowStyle = { fontSize: 16, borderBottom: "1px solid #cccccc", color: "white", textAlign: "left" }


const TableRow = ({ log, x, disableAction, setDisableAction, cancelOrder, setOrders, botId }) => {

    const logTimer = (new Date().getTime() - new Date(log.created_at).getTime()) / 1000;

    const [timeLeft, setTimeLeft] = useState(log.timer ? parseInt(logTimer ? log.timer - logTimer : log.timer) : '-');
    useEffect(() => {
        if (log.order_status === 'open') {
            setTimeLeft(parseInt(logTimer ? log.timer - logTimer : log.timer));
        } else {
            setTimeLeft('-');
        }
    }, [log])
    useEffect(() => {
        if (log.order_status === 'open') {
            // // exit early when we reach 0
            if (!timeLeft) return;

            // save intervalId to clear the interval when the
            // component re-renders
            const intervalId = setInterval(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);

            // clear interval on re-render to avoid memory leaks
            return () => clearInterval(intervalId);
            // add timeLeft as a dependency to re-rerun the effect
            // when we update it
        }
    }, [timeLeft]);

    return (
        <tr>
            {/* <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}>{log.symbol || '-'}</th> */}
            {/* <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}>{log.side || '-'}</th> */}
            <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}>{log.order_price || '-'}</th>
            <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}>{log.size || '-'}</th>
            <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}>{(log.remaining || log.size) || '-'}</th>
            {/* <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}>{log.source || '-'}</th> */}
            {/* <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}>{isNaN(log.source_symbol) && log.source_symbol || '-'}</th> */}
            {/* <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}>{log.spread || '-'}</th> */}
            <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}>{(log.sensitivity_price &&
                !log?.sensitivity_price?.toString()?.startsWith("0") ? log?.sensitivity_price?.toFixed(4) : log.sensitivity_price) || '-'}</th>
            <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}>{log.order_status === 'open' ? `${timeLeft}(s)` : '-'}</th>
            <th style={{ ...tableSubRowStyle, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', ...(log.order_status !== 'open' && { color: 'grey' }) }}>{moment(log.created_at).format('h:mm:ss a') || '-'}</th>
            <th style={{ ...tableSubRowStyle, ...(log.order_status !== 'open' && { color: 'grey' }) }}><span>{log.order_status === 'open' ? <Button
                disabled={disableAction}
                onClick={() => {
                    try {
                        setDisableAction(true);
                        message.loading({ content: 'Waiting...', key: 'cancel', duration: 0 });
                        cancelOrder(x.id, true, false, botId).then(res => {
                            if (res.error) {
                                // message.error(res.error)
                                setOrders(previousState => {
                                    let newOrders = [...previousState]
                                    newOrders.forEach(order => {
                                        if (order.id === x.id) {
                                            order.logs.forEach(log => {
                                                if (log.id === x.id && log.order_status === 'open') {
                                                    log.order_status = 'canceled';
                                                }
                                            })
                                        }
                                    })
                                    return newOrders;
                                })
                            }

                            setOrders(previousState => {
                                let newOrders = [...previousState]
                                newOrders.forEach(order => {
                                    if (order.id === res.id) {
                                        order.logs.forEach(log => {
                                            if (log.id === res.id && log.order_id === res.order_key) {
                                                log.order_status = 'canceled';
                                            }
                                        })
                                    }
                                })
                                return newOrders;
                            })
                            setDisableAction(false);
                            message.destroy('cancel');
                            console.log(res);
                        }).catch(err => {
                            setDisableAction(false);
                            message.error(err.message)
                        })
                    } catch (err) {
                        message.error(err.message)
                    }

                }}
                style={{ backgroundColor: "#161616", color: "white", borderRadius: 10 }}>Cancel</Button> : log.order_status}</span></th>
        </tr>
    );
};

export default TableRow;